/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_Delete_HintInputs */

const cs_settings_office_legal_entity_delete_hint = /** @type {(inputs: Settings_Office_Legal_Entity_Delete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky, které tuto firmu používaly, převezmou zastřešující firmu kanceláře. Akci nelze vrátit.`)
};

const en_settings_office_legal_entity_delete_hint = /** @type {(inputs: Settings_Office_Legal_Entity_Delete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venues that used this company will inherit the office umbrella. This cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Venues that used this company will inherit the office umbrella. This cannot be undone." |
*
* @param {Settings_Office_Legal_Entity_Delete_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_delete_hint = /** @type {((inputs?: Settings_Office_Legal_Entity_Delete_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_Delete_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_delete_hint(inputs)
	return cs_settings_office_legal_entity_delete_hint(inputs)
});